<template>
  <div class="form-group">
    <label :for="inputId">
      {{ label }} ({{ $t('{width} pixels width', {width: 600 }) }})
    </label>
    <div>
      <template v-if="media">
        <div class="tw:group/item tw:relative tw:mb-2 tw:cursor-pointer tw:bg-zinc-100 tw:min-h-[60px]">
          <img :src="media.url || media.original_url" class="img-fluid" :alt="label">
          <template v-if="media.links?.delete">
            <Button type="button"
                    variant="destructive"
                    size="sm"
                    class="tw:absolute tw:right-3 tw:bottom-3  tw:invisible tw:group-hover/item:visible"
                    @click="onDelete"
            >
              {{ $t('Delete the image') }}
            </Button>
          </template>
        </div>
      </template>
      <div v-else class="mt-2">
        <template v-if="uploadState">
          <div class="tw:flex tw:justify-start tw:items-center tw:py-3 tw:gap-2">
            <loader-circle class="tw:animate-spin tw:size-6 tw:text-blue-500" />
            <span>{{ uploadState === 'uploading' ? $t('Uploading…') : $t('Processing…') }}</span>
          </div>
        </template>
        <template v-else>
          <MediaUploader
            :id="inputId"
            @file-input="onFileInput"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import MediaUploader from '@/components/marketing-message/MediaUploader.vue';
import { Button } from '@/shadcn/components/ui/button/index.js';
import { useMediaUpload } from '@/composables/useMediaUpload';
import { LoaderCircle } from "@lucide/vue";

const props = defineProps({
  label: { type: String, required: true },
  inputId: { type: String, required: true },
  media: { type: Object, default: null },
  uploadUrl: { type: String, required: true },
  collectionName: { type: String, required: true },
});

const emit = defineEmits(['files-uploaded', 'delete']);

const { uploadState, uploadAndProcessFiles } = useMediaUpload(props.uploadUrl, props.collectionName);

const onFileInput = async (files: FileList) => {
  const updatedFiles = await uploadAndProcessFiles(files);
  emit('files-uploaded', updatedFiles);
};

const onDelete = () => {
  emit('delete');
};
</script>
